/**
 * 매물탐색 필터 옵션 데이터 — PC/모바일 공통 단일 소스
 */

// ── 물건 유형 ──

export const ESTATE_CATEGORIES = [
  {
    value: "10,11,17,18,19,15",
    label: "상가・사무실・공장",
    subOptions: [
      { value: 12, label: "상업용건물" },
      { value: "10,11", label: "상가·사무실" },
      { value: "17,19", label: "공장·창고" },
      { value: 18, label: "지식산업센터" },
      { value: 15, label: "숙박시설" },
    ],
  },
  {
    value: "0,1,2,20",
    label: "아파트・오피스텔",
    subOptions: [
      { value: 0, label: "아파트" },
      { value: 1, label: "주상복합" },
      { value: 2, label: "오피스텔" },
      { value: 20, label: "생활숙박시설" },
    ],
  },
  {
    value: "7,8,3,4,5,6",
    label: "빌라・주택",
    subOptions: [
      { value: 7, label: "연립" },
      { value: 8, label: "다세대" },
      { value: "3,5", label: "단독·전원주택" },
      { value: 4, label: "다가구" },
      { value: 6, label: "상가주택" },
    ],
  },
  {
    value: "16",
    label: "토지",
    subOptions: [{ value: 16, label: "토지" }],
  },
];

export const ESTATE_TYPES = [
  { value: 16, label: "토지" },
  { value: 12, label: "상업용건물" },
  { value: 10, label: "상가점포" },
  { value: 11, label: "사무실" },
  { value: 2, label: "오피스텔" },
  { value: 17, label: "공장" },
  { value: 19, label: "창고" },
  { value: 18, label: "지식산업센터" },
  { value: 15, label: "숙박시설" },
  { value: 0, label: "아파트" },
  { value: 1, label: "주상복합" },
  { value: 7, label: "연립" },
  { value: 8, label: "다세대" },
  { value: 3, label: "단독" },
  { value: 4, label: "다가구" },
  { value: 6, label: "상가주택" },
  { value: 5, label: "전원주택" },
  { value: 14, label: "기타건물" },
  { value: 20, label: "생활숙박시설" },
];

// ── 거래 유형 ──

export const DEAL_TYPES = [
  { value: 0, label: "매매" },
  { value: 1, label: "전세" },
  { value: 2, label: "월세" },
];

// ── 용도지역 (피그마 기준 6그룹) ──

export const USE_AREA_GROUPS = [
  {
    label: "주거지역",
    options: [
      { value: 1, label: "1종전용 주거" },
      { value: 2, label: "2종 전용 주거" },
      { value: 3, label: "1종 일반 주거" },
      { value: 4, label: "2종 일반 주거" },
      { value: 5, label: "3종 일반 주거" },
      { value: 6, label: "준 주거" },
    ],
  },
  {
    label: "상업지역",
    options: [
      { value: 7, label: "중심 상업" },
      { value: 8, label: "일반 상업" },
      { value: 9, label: "근린 상업" },
      { value: 10, label: "유통 상업" },
    ],
  },
  {
    label: "공업지역",
    options: [
      { value: 11, label: "전용 공업" },
      { value: 12, label: "일반 공업" },
      { value: 13, label: "준 공업" },
    ],
  },
  {
    label: "녹지지역",
    options: [
      { value: 14, label: "보전녹지" },
      { value: 15, label: "생산녹지" },
      { value: 16, label: "자연녹지" },
    ],
  },
  {
    label: "관리지역",
    options: [
      { value: 17, label: "계획관리" },
      { value: 18, label: "생산관리" },
      { value: 19, label: "보전관리" },
    ],
  },
  {
    label: "기타",
    options: [
      { value: 20, label: "농림" },
      { value: 21, label: "자연환경 보전" },
    ],
  },
];

// ── 층수 ──

export const FLOOR_OPTIONS = [
  { value: 1, label: "반지층/지하" },
  { value: 2, label: "1층" },
  { value: 3, label: "2-5층" },
  { value: 4, label: "6-9층" },
  { value: 5, label: "10층 이상" },
];

// ── 사용 승인일 ──

export const APPROVAL_OPTIONS = [
  { value: 5, label: "5년 이내" },
  { value: 10, label: "10년 이내" },
  { value: 15, label: "15년 이내" },
  { value: 20, label: "20년 이내" },
  { value: 21, label: "20년 이상" },
];

// ── 입주 가능일 ──

export const AVAILABLE_DATE_OPTIONS = [
  { value: "0", label: "즉시 입주" },
  { value: "1", label: "1개월 이내" },
  { value: "2", label: "2개월 이내" },
];

// ── 내부구조 ──

export const ROOM_COUNT_OPTIONS = [
  { value: 1, label: "1개" },
  { value: 2, label: "2개" },
  { value: 3, label: "3개" },
  { value: 4, label: "4개" },
  { value: 5, label: "5개 이상" },
];

export const BATHROOM_COUNT_OPTIONS = [
  { value: 1, label: "1개" },
  { value: 2, label: "2개" },
  { value: 3, label: "3개" },
  { value: 4, label: "4개" },
  { value: 5, label: "5개 이상" },
];

// ── 방향 ──

export const DIRECTION_OPTIONS = [
  { value: 1, label: "동" },
  { value: 2, label: "서" },
  { value: 3, label: "남" },
  { value: 4, label: "북" },
  { value: 5, label: "남동" },
  { value: 6, label: "남서" },
  { value: 7, label: "북동" },
  { value: 8, label: "북서" },
];

// ── 가격 설정 ──

export const PRICE_CONFIG = {
  sale: { min: 0, max: 300000, step: 1000 },
  deposit: { min: 0, max: 200000, step: 1000 },
  monthly: { min: 0, max: 500, step: 10 },
};

// ── 면적 설정 ──

export const M2_TO_PYEONG = 0.3025;

export const AREA_CONFIG = {
  pyeong: { min: 0, max: 1000, step: 10, label: "평" },
  sqm: { min: 0, max: 3306, step: 33, label: "m²" },
};

// ── 정렬 ──

export const ORDER_OPTIONS = [
  { label: "최신순", value: { type: "creation_date", order: "increase" } },
  { label: "오래된 순", value: { type: "creation_date", order: "decrease" } },
  { label: "가격높은순", value: { type: "price", order: "increase" } },
  { label: "가격낮은순", value: { type: "price", order: "decrease" } },
];

// ── 페이지 크기 ──

export const LIMIT_OPTIONS = [
  { label: "20개씩 보기", value: 20 },
  { label: "30개씩 보기", value: 30 },
  { label: "50개씩 보기", value: 50 },
];

// ── 빈 필터 상태 ──

export const EMPTY_FILTER = {
  deal_type: [],
  randType: [],
  useArea: [],
  floorType: [],
  availableDate: [],
  roomCnt: [],
  bathroomCnt: [],
  direction: [],
  approvalYear: null,
  minPrice: null,
  maxPrice: null,
  minDeposit: null,
  maxDeposit: null,
  minMonthly: null,
  maxMonthly: null,
  // 면적은 항상 m² 단위로 저장
  minArea: null,
  maxArea: null,
  areaUnit: "pyeong",
  selectedCategory: null,
};

// ── 가격 포맷 ──

// 칩/라벨용: "10만", "1억", "30억" (단위 포함)
export const formatPrice = (val) => {
  if (val == null) return "";
  if (val === 0) return "0";
  if (val >= 10000) {
    const eok = val / 10000;
    return Number.isInteger(eok) ? `${eok}억` : `${eok.toFixed(1)}억`;
  }
  return `${val.toLocaleString()}만`;
};

// 입력필드용: 숫자만 표시 (unit="만원"이 별도로 붙으므로)
export const formatPriceInput = (val) => {
  if (val == null) return "";
  if (val === 0) return "0";
  return val.toLocaleString();
};

export const parsePrice = (text) => {
  const n = parseFloat(text.replace(/[^\d.]/g, ""));
  return isNaN(n) ? null : n;
};

// 입력 필드 하단 치환값: 10,000만원 이상일 때 억원 단위로 표시
// 만 단위 첫째자리까지 (ex. 105,000 → "10.5억 원")
export const convertPriceLabel = (val) => {
  if (val == null || val < 10000) return "";
  const eok = val / 10000;
  const formatted = Number.isInteger(eok) ? `${eok}` : `${eok.toFixed(1)}`;
  return `${formatted}억 원`;
};
